export default __webpack_public_path__ + "static/media/09-yes-and.d82cd681.svg";